import { Caption, Paragraph, Stack } from '@mediahuis/chameleon-react';
import React, { useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useAuthenticationContext } from '../../providers/AuthenticationProvider';
import { useBrandGroupConfig } from '../../hooks/useBrandGroupConfig';
import { useQueryParams } from '../../hooks/useQueryParams';
import { OtherAccountButton } from '../OtherAccountButton';
import { useTracking } from '../../hooks/useTracking';
import { EventActionValues, EventCategoryValues, EventLabelValues } from '../../types/tracking';

export function InvitationErrorIdentityAlreadyHasRole() {
  const { t } = useTranslation();
  const { trackEventWithCategory } = useTracking();
  const brandGroupConfigHook = useBrandGroupConfig();
  const { brand, name } = useQueryParams();
  const brandConfig = brandGroupConfigHook.getBrandConfigFromBrandId(brand);
  const { user } = useAuthenticationContext();
  const hasTrackedError = useRef(false);

  const capitalizedName = name ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : name;

  useEffect(() => {
    if (brand && !hasTrackedError.current) {
      trackEventWithCategory(
        EventActionValues.Show,
        EventLabelValues.InvitationErrorAlreadyHasRole,
        EventCategoryValues.Invitation
      );
      hasTrackedError.current = true;
    }
  }, [brand, trackEventWithCategory]);

  const handleOtherAccountClick = () => {
    trackEventWithCategory(
      EventActionValues.Click,
      EventLabelValues.InvitationErrorAlreadyHasRoleOtherUser,
      EventCategoryValues.Invitation
    );
  };

  const subtitleKey = capitalizedName
    ? 'invitation.error.identityAlreadyHasRole.subtitleText'
    : 'invitation.error.identityAlreadyHasRole.subtitleTextAlternative';

  return (
    <>
      <Paragraph size="Paragraph" className="bold text-center mt-7 mb-3">
        {t('invitation.error.identityAlreadyHasRole.titleText')}
      </Paragraph>
      <Caption size="lg" className="text-center">
        <Trans i18nKey={subtitleKey} values={{ brand: brandConfig?.name, name: capitalizedName }} />
      </Caption>
      <Stack
        flexDirection="column"
        alignItems="center"
        style={{
          backgroundColor: '#f5f5f5',
          padding: '1rem',
          borderRadius: '4px',
        }}>
        <Caption size="lg" className="bold" style={{ marginBottom: '0' }}>
          {t('invitation.error.identityAlreadyHasRole.loggedInAs')}
        </Caption>
        <Caption size="lg" style={{ marginTop: '0.5rem' }}>
          {user?.email}
        </Caption>
      </Stack>
      <Caption size="lg" className="text-center">
        {t('invitation.error.identityAlreadyHasRole.alreadyLinked')}
      </Caption>
      <OtherAccountButton
        appearance="primary"
        onClick={handleOtherAccountClick}
        label={t('invitation.error.identityAlreadyHasRole.loginWithOwnAccount') as string}
        screen="login"
        style={{ marginBottom: '0.7rem' }}
        reauthenticate
      />
      <OtherAccountButton
        onClick={handleOtherAccountClick}
        label={t('invitation.error.identityAlreadyHasRole.createAccount') as string}
        screen="register"
        style={{ marginTop: '0' }}
      />
    </>
  );
}
